import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  position: fixed;
  z-index: 20;
  bottom: 11vh;
  right: 1vw;
  background-color: rgba(88, 101, 242, 1);
  color: white;
  width: 250px;
  border-radius: 10px;
  padding: 1rem;
  display: ${({ screenWidth, isConnected }) =>
    screenWidth < 992 || isConnected ? 'none' : 'block'};
  p {
    margin-bottom: 1rem;
  }
`;

export default Container;
